import styled from 'styled-components';

import { Menu as MenuComponent } from '@xingternal/menu';
import { spaceL, spaceM, spaceXL } from '@xingternal/tokens';
import { Headline as HeadlineComponent } from '@xingternal/typography';

export const Menu = styled(MenuComponent)<{ $hasReducedPadding: boolean }>`
  width: 350px;
  padding: ${({ $hasReducedPadding }) => ($hasReducedPadding ? spaceL : spaceXL)};
`;

export const Headline = styled(HeadlineComponent)`
  display: flex;
  align-items: center;
`;

export const SliderContainer = styled.div`
  margin: ${spaceM};
  margin-bottom: 0;
`;
